module.exports = __webpack_public_path__ + "static/networks5-6dc911d1e432fcd94dac8dcd693628d4.jpg";